export function getCampaignTypeFromName(campaignName: string): string | null {
  const mapping: { [key: string]: string } = {
    'Call Campaign': 'call',
    'WhatsApp Campaign': 'whatsapp',
    'Email Campaign': 'email',
    'LinkedIn Campaign': 'linkedin',
    'Omni-Channel Campaign': 'omni'
  };

  return mapping[campaignName] || null;
}
